import $ from 'jquery';
import header from '../../../views/partials/header/header';
import c_test from '../../../views/partials/test/test.js';
import c_quiz from '../../../views/partials/quiz/quiz.js';
import menu from '../../../views/partials/menu/menu';

export default {
    init() {

    },

    finalize() {
        header();
        c_test();
        c_quiz();
        menu();

        $(window).on('scroll', function(){
            var offset = $('.visual').height() - 100;
            if($(this).scrollTop()>= offset){
                $('#hamburger-toggle').addClass('dark');
                $('.menu-desktop').addClass('dark');
            } else {
                $('#hamburger-toggle').removeClass('dark');
                $('.menu-desktop').removeClass('dark');
            }
          });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js